import { RouteObject, useNavigate } from "react-router";
import { Navigate, useLocation, useParams } from "react-router";
import { IngestConfigurePlaceholderContext } from "../Components/Modals/ModalCreateOrUpdatePlaceholder/modal-ingest-config-placeholder-create-or-update";
import { assetService, cacheService } from "../Core/Api/services";

import BasketMainFrame from "../Pages/Basket/basket";
import BasketCheckout from "../Pages/Basket/BasketCheckout/basket-checkout";
import BasketSuccess, { InvoiceContext } from "../Pages/Basket/BasketSuccess/basket-success";
import CatalogIndex from "../Pages/Catalog/CatalogIndex/catalog-index-home";
import Demo from "../Pages/Demo";
import DemoCards from "../Pages/Demo/DemoCards/demo-cards";
import DemoCore from "../Pages/Demo/DemoCore/demo-core";
import DemoSamples from "../Pages/Demo/DemoSamples/demo-samples";
import DemoTables from "../Pages/Demo/DemoTables/demo-tables";
import LoginNewPassword from "../Pages/Login/LoginNewPassword/login-new-password";
import OrderListBasic from "../Pages/Orders/OrderList/order-list-basic";
import OrderSingleAdvanced from "../Pages/Orders/OrderSingle/order-single-advanced";
import Register from "../Pages/Register";
import RegisterProfileDetails from "../Pages/Register/RegisterProfileDetails";
import RegisterProfileUser from "../Pages/Register/RegisterProfileUser";
import Title from "../Pages/Title/title";

import Dashboard from "../Pages/admin/Dashboard/dashboard";
import DashboardApprovals from "../Pages/admin/Dashboard/DashboardApprovals/dashboard-approvals";
import DashboardOverview from "../Pages/admin/Dashboard/DashboardOverview/dashboard-overview";

import AdminCollection from "../Pages/admin/Collection/collection-dashboard";
import AdminCollectionSingle from "../Pages/admin/Collection/CollectionSingle/collection-single";

import AdminInventory from "../Pages/admin/Inventory/InventoryIndex/inventory-index";
import AdminInventoryAdvancedQueries from "../Pages/admin/Inventory/InventoryIndex/InventoryAdvancedQueries/inventory-advanced-queries";
import AdminInventoryAssets from "../Pages/admin/Inventory/InventoryIndex/InventoryAssets/inventory-assets";
import AdminInventoryCrossLevel from "../Pages/admin/Inventory/InventoryIndex/InventoryCrossLevel/inventory-cross-level";
import InventoryKdm from "../Pages/admin/Inventory/InventoryIndex/InventoryKdm/inventory-kdm";
import AdminInventoryTitles from "../Pages/admin/Inventory/InventoryIndex/InventoryTitles/inventory-titles";

import AdminOrder from "../Pages/Orders/OrderIndex/order-index";
import OrderItemDetails from "../Pages/Orders/OrderItemAll/order-item-list-all";
import AdminOrderCustomerOrders from "../Pages/Orders/OrderItemCustomer/order-item-list-customer";
import OrderInternal from "../Pages/Orders/OrderItemInternal/order-item-list-internal";
import OrderItemQuoteDetails from "../Pages/Orders/OrderItemQuotes/order-item-list-quotes";

import Contracts from "../Pages/Contracts/contracts-index";
import ContractsAndRights from "../Pages/Contracts/ContractsAndRights/contracts-and-rights";
import ContractTitles from "../Pages/Contracts/ContractsLatestTitles/contracts-latest-titles";

import AdminCustomersCustomers from "../Pages/admin/Customers/CustomerIndex/Customers/customers";
import AdminCustomerContractSingle from "../Pages/admin/Customers/CustomerSingle/customer-contract-single";
import AdminCustomersSingle from "../Pages/admin/Customers/CustomerSingle/customer-single";

import AdminProviders from "../Pages/admin/Providers/ProvidersIndex/providers-index";
import AdminProvidersSingle from "../Pages/admin/Providers/ProvidersSingle/providers-single";

import AdminTitleSingle from "../Pages/admin/Inventory/InventoryTitleSingle/title-single";
import AdminTitleSingleActivities from "../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleActivities/title-single-activities";
import AdminTitleSingleAssets from "../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleAssets/title-single-assets";
import AdminTitleSingleContentsAndMetadata from "../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleContentsAndMetadata/title-single-metadata";
import AdminTitleSingleContracts from "../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleContracts/title-single-contracts";
import AdminTitleSingleMediaAndCollections from "../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleMediaAndCollections/title-single-media-and-collections";
import AdminTitleSingleOrders from "../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleOrders/title-single-orders";
import AdminTitleSingleShares from "../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleShares/title-single-shares";

import AdminIngestConfigurePlaceholder from "../Pages/admin/Ingest/IngestConfigurePlaceholder/ingest-config-placeholder";
import AdminIngest from "../Pages/admin/Ingest/IngestIndex/ingest-index";
import AdminIngestApproved from "../Pages/admin/Ingest/IngestIndex/IngestApproved/ingest-approved";
import AdminIngestPacksIndex from "../Pages/admin/Ingest/IngestIndex/IngestPacks/IngestPacksIndex/ingest-config-pack-list";
import AdminIngestPacksSingle from "../Pages/admin/Ingest/IngestIndex/IngestPacks/IngestPacksSingle/ingest-config-pack-single";
import AdminIngestProcessing from "../Pages/admin/Ingest/IngestIndex/IngestProcessing/ingest-processing";
import AdminIngestRejected from "../Pages/admin/Ingest/IngestIndex/IngestRejected/ingest-rejected";
import AdminIngestRequested from "../Pages/admin/Ingest/IngestIndex/IngestRequested/ingest-requested";
import AdminIngestMissingAssetRequest from "../Pages/admin/Ingest/IngestMissingAssetRequest";
import AdminIngestNewRequest from "../Pages/admin/Ingest/IngestNewRequest/ingest-new-request";

import AdminStorefront from "../Pages/admin/Storefront/StorefrontIndex";

import AdminSettings, { SettingsGroups } from "../Pages/admin/Settings/settings";
import AdminSettingsBroadcasters from "../Pages/admin/Settings/SettingsBroadcasters/settings-broadcasters";
import AdminSettingsGlobal from "../Pages/admin/Settings/SettingsGlobal/settings-global";
import AdminSettingsJobs from "../Pages/admin/Settings/SettingsJobs/settings-jobs";
import AdminSettingsRolesAndPermissions from "../Pages/admin/Settings/SettingsRolesAndPermissions/settings-roles-and-permissions";
import AdminSettingsUsers from "../Pages/admin/Settings/SettingsUsers/settings-users";

import ViewLink from "../Pages/ViewLink/view-link";
import ViewLinkError from "../Pages/ViewLink/ViewLinkError";
import ViewLinkExpired from "../Pages/ViewLink/ViewLinkExpired";

import { ReactNode, useCallback, useEffect } from "react";
import AdamIndex from "../Components/Adam/adam-home";
import AdamSources from "../Components/Adam/adam-sources";
import AdamTrailers from "../Components/Adam/adam-trailers";
import { AclAssetAccessLevel } from "../Core/Api/Types/acl-asset-access-level";
import { AclTypes } from "../Core/Api/Types/acl-types";
import { DbAssetObjectInfos } from "../Core/Api/Types/db-asset-object-infos";
import { Licences } from "../Core/Api/Types/licences";
import { ObjectClass } from "../Core/Api/Types/object-class";
import { ObjectLayer } from "../Core/Api/Types/object-layer";
import { ObjectStatus } from "../Core/Api/Types/object-status";
import { ObjectType } from "../Core/Api/Types/object-type";
import { PlatformMode } from "../Core/Api/Types/platform-mode";
import GlobalConst from "../Core/Utils/Constants/globals";
import DashboardActivities from "../Pages/admin/Dashboard/Activities/dashboard-activities";
import Cockpit from "../Pages/admin/Dashboard/Cockpit/cockpit";
import DashboardConversations from "../Pages/admin/Dashboard/DashboardConversations/dashboard-conversations";
import DashboardPurge from "../Pages/admin/Dashboard/DashboardPurge/dashboard-purge";
import DashboardQC from "../Pages/admin/Dashboard/DashboardQC/dashboard-qc";
import KpiWorkflow from "../Pages/admin/Dashboard/KpiWorkflow/kpi-workflow";
import IngestConfigColset from "../Pages/admin/Ingest/IngestConfigureColset/ingest-config-colset";
import InventoryAssetSingle from "../Pages/admin/Inventory/InventoryAssetSingle/asset-single";
import AssetSingleActions from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleActions/asset-single-actions";
import AssetSingleActivities from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleActivities/asset-single-activities";
import AssetSingleHierarchy from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleHierarchy/asset-single-hierarchy";
import AssetSingleMediaFiles from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleMediaFiles/asset-single-media-files";
import AssetSingleMetadata from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleMetadata/asset-single-metadata";
import AssetSingleOrders from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleOrders/asset-single-orders";
import AssetSinglePreview from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSinglePreview/asset-single-preview";
import AssetSingleQuotas from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleQuotas/asset-single-quotas";
import AssetSingleShares from "../Pages/admin/Inventory/InventoryAssetSingle/AssetSingleShares/asset-single-shares";
import InventoryBulkMetaImporter from "../Pages/admin/Inventory/InventoryIndex/InventoryBulkMetaImporter/inventory-bulk-meta-importer";
import InventoryBundlesDashboard from "../Pages/admin/Inventory/InventoryIndex/InventoryBundlesDashboard/inventory-bundles-dashboard";
import InventoryCreateTitle from "../Pages/admin/Inventory/InventoryIndex/InventoryCreateTitle/inventory-create-title";
import AdminSettingsAgentsAndLicenses from "../Pages/admin/Settings/SettingsAgentsAndLicences/settings-agents-and-licences";
import AdminSettingsCopyPlatform from "../Pages/admin/Settings/SettingsCopyPlatform/settings-copy-platform";
import AdminSettingsExportSessions from "../Pages/admin/Settings/SettingsExportSessions/settings-export-sessions";
import AdminSettingsLiquidExportEdit from "../Pages/admin/Settings/SettingsExportSessions/settings-liquid-export-edit";
import AdminSettingsFormats from "../Pages/admin/Settings/SettingsFormats/settings-formats";
import EditOrCreateJobRule from "../Pages/admin/Settings/SettingsJobRulesManagement/edit-or-create-job-rule";
import AdminSettingsJobRulesManagement from "../Pages/admin/Settings/SettingsJobRulesManagement/settings-job-rules-management";
import AdminSettingsLegacyImporter from "../Pages/admin/Settings/SettingsLegacyImporter/settings-legacy-importer";
import AdminSettingsMailingListManagement from "../Pages/admin/Settings/SettingsMailingListManagement/settings-mailing-list-management";
import AdminSettingsManualTasks from "../Pages/admin/Settings/SettingsManualTasks/settings-manual-tasks";
import AdminSettingsManualTasksTemplateConfig from "../Pages/admin/Settings/SettingsManualTasks/settings-manual-tasks-template-config";
import AdminSettingsMetadataFields from "../Pages/admin/Settings/SettingsMetadataFields/settings-metadatafields";
import EditOrCreateMetadataViews from "../Pages/admin/Settings/SettingsMetadataViews/edit-or-create-metadata-views";
import AdminSettingsMetadataViewsManagement from "../Pages/admin/Settings/SettingsMetadataViews/settings-metadata-views";
import AdminSettingsPlanningResources from "../Pages/admin/Settings/SettingsPlanning/settings-planning-resources";
import AdminSettingsPriceRulesManagement from "../Pages/admin/Settings/SettingsPriceRulesManagement/settings-price-rules-management";
import AdminSettingsProductsManagement from "../Pages/admin/Settings/SettingsProductManagement/settings-products-management";
import AdminSettingsPurgeRules from "../Pages/admin/Settings/SettingsPurgeRules/settings-purge-rules";
import AdminSettingsStatusTransitions from "../Pages/admin/Settings/SettingsStatusTransitions/settings-status-transitions";
import AdminSettingsStorages from "../Pages/admin/Settings/SettingsStorages/settings-storages";
import AdminSettingsSystemAlerts from "../Pages/admin/Settings/SettingsSystemAlerts/settings-system-alerts";
import AdminSettingsWorkflows from "../Pages/admin/Settings/SettingsWorkflows/settings-workflows";
import Shares from "../Pages/admin/Shares/shares-index";
import SharesList from "../Pages/admin/Shares/shares-list";
import Billing from "../Pages/Billing/billing-index";
import BillingCurrentMonth from "../Pages/Billing/CurrentMonth/billing-current-month";
import BillingInvoiceDetails from "../Pages/Billing/Invoices/billing-invoice-details";
import BillingInvoices from "../Pages/Billing/Invoices/billing-invoices";
import BillingOffer from "../Pages/Billing/Offer/billing-offer";
import BundleMaker from "../Pages/Bundlemaker/bundlemaker";
import CatalogSingle from "../Pages/Catalog/CatalogSingle/catalog-single";
import DownloadLink from "../Pages/Download/download-link-center";
import Drive from "../Pages/Drive/drive-index";
import DriveExternalAccess from "../Pages/Drive/drive-external-access";
import DriveTrash from "../Pages/Drive/drive-trash";
import DriveTreeview from "../Pages/Drive/drive-treeview";
import Login from "../Pages/Login/login";
import LoginByKey from "../Pages/Login/login-by-key";
import LoginExternalAccess from "../Pages/Login/login-external-access";
import LoginOkta from "../Pages/Login/login-okta";
import OrderFollowup from "../Pages/Orders/OrderFollowup/order-followup";
import OrderItemSearch from "../Pages/Orders/OrderSearch/order-item-search";
import PlanningCalendar from "../Pages/Planning/Calendar/planning-calendar";
import PlanningKanban from "../Pages/Planning/Kanban/planning-kanban";
import Planning from "../Pages/Planning/planning-index";
import ReportingDataExporter from "../Pages/Reporting/DataExporter/reporting-data-exporter";
import ReportingMetrics from "../Pages/Reporting/Metrics/reporting-metrics";
import Reporting from "../Pages/Reporting/reporting-index";
import { Scribetool } from "../Pages/Scribetool/scribetool";
import LockedUser from "../Pages/static/locked-user";
import NewUserWaiting from "../Pages/static/new-user";
import SupportDocuments from "../Pages/Support/Documents/support-documents";
import Support from "../Pages/Support/support-index";
import { Timetool } from "../Pages/Timetool/Timetool";
import QcTool from "../Pages/Tools/QC/tool-qc";
import ViewLinkProcessing from "../Pages/ViewLink/ViewLinkProcessing";
import { AclMatch, UserHasAcl, UserHasAcls, UserHasLicence } from "../Utils/helpers";
import useCustomSnackbar from "../Utils/Hooks/useCustomSnackbar";
import AdminSettingsSystemCultures from "../Pages/admin/Settings/SettingsSystemCultures/settings-system-cultures";
import LoginVerify from "../Pages/Login/LoginVerify/login-verify";
import OrderWatermarks from "../Pages/Orders/OrderWatermarks/order-watermarks";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ReportingCatalog from "../Pages/Reporting/Catalog/reporting-catalog";
import SettingsDiagramDesigner from "../Pages/admin/Settings/SettingsDiagramDesigner/settings-diagram-designer";
import AdminSettingsYoutubeChannels from "../Pages/admin/Settings/SettingsYoutubeChannels/settings-youtube-channels";
import LoginForgotPasswordRequest from "../Pages/Login/LoginPasswordRecovery/login-password-recovery";
import LoginForgotPasswordReset from "../Pages/Login/LoginResetForgotPassword/login-reset-forgot-password";
import AdminTitleDrive from "../Pages/admin/Inventory/InventoryTitleSingle/TitleSingleDrive/title-single-drive";
import { PermissionType } from "../Core/Api/Types/permission-type";
import AdminSettingsNamingRules from "../Pages/admin/Settings/SettingsNamingRules/settings-naming-rules";

type Props = {
  children: ReactNode;
};
const ProtectedRoute = ({ children }: Props) => {
  // Check if we are logged
  const isLoggedIn = cacheService.IsLoggedIn();
  const location = useLocation();

  if (!isLoggedIn) {
    console.warn("Auth missing -> redirect to login page");
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export type PageHeadRouteProps = {
  children: ReactNode;
  pageTitle: string;
  rootLink: string;
  navType: NavTypes;
};

export enum NavTypes {
  Breadcrumb = "breadcrumb",
  LinkTabs = "linktabs",
  None = "none",
}

export type LinktabRouteProps = {
  children: ReactNode;
  linkTitle: string;
  acls?: AclTypes[];
  licence?: Licences;
  platformModes?: PlatformMode[] | undefined;
  accessLevel?: AclAssetAccessLevel;
  hide?: boolean;
  matchingPaths?: string[];
  aclMatch?: AclMatch;
};

const PageHeadRoute = (props: PageHeadRouteProps) => {
  const { pageTitle, navType, rootLink, children } = props;

  return children;
};

const LinkTabRoute = (props: LinktabRouteProps) => {
  const { linkTitle, children, matchingPaths = [] } = props;
  return children;
};

type PlatformRouteProps = {
  [PlatformMode.Adam]: ReactNode | string;
  [PlatformMode.Browser]: ReactNode | string;
  [PlatformMode.Distribution]: ReactNode | string;
};

const PlatformRoute = (props: PlatformRouteProps) =>
  typeof props[cacheService.GetPlatformMode()] === "string" ? (
    <Navigate to={props[cacheService.GetPlatformMode()] as string} replace />
  ) : (
    (props[cacheService.GetPlatformMode()] as ReactNode)
  );

const DriveRouteOverride = ({ children }: Props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const enqueueCustomSnackbar = useCustomSnackbar();
  const params = useParams();
  const titleId: number = parseInt(params.id!) || 0;

  const isDriveOnly = UserHasAcl(AclTypes.aclDistributionDriveOnly);
  const driveLicense = UserHasLicence(Licences.Drive);

  const handleTitleNotFound = useCallback(() => {
    enqueueCustomSnackbar(t("alert:error.titleNotFound", { id: titleId }), "error");
    navigate(-1);
  }, [titleId, enqueueCustomSnackbar, navigate]);

  useEffect(() => {
    if (!isDriveOnly || !driveLicense) return;

    if (titleId <= 0) {
      handleTitleNotFound();
      return;
    }

    assetService.GetObjectLightById(titleId, 1).then((response) => {
      if (!response.success || !response.graph) {
        handleTitleNotFound();
        return;
      }

      const title = response.graph;

      if (!location.pathname.includes(`${routePaths.title.path}/${title.id}/drive`)) {
        navigate(`${routePaths.title.path}/${title.id}/drive`, {
          state: location.state,
          replace: true,
        });
      }
    });
  }, [isDriveOnly, handleTitleNotFound]);

  return <>{children}</>;
};

const routePaths = {
  home: {
    path: "/",
  },
  drive: {
    path: "/drive",
  },
  driveAdvancedSearch: {
    path: "advanced-search",
  },
  driveTrash: {
    path: "trash",
  },
  driveExternalAccess: {
    path: "external-accesses",
  },
  driveAdvancedQueries: {
    path: "advanced-queries",
  },
  catalog: {
    path: "/catalog",
  },
  demo: {
    path: "/demo",
  },
  demoCore: {
    path: "core",
  },
  demoSamples: {
    path: "samples",
  },
  demoTables: {
    path: "tables",
  },
  demoCards: {
    path: "cards",
  },
  // Basket section
  basket: {
    path: "/basket",
  },
  basketCheckout: {
    path: "/basket/checkout",
  },
  basketSuccess: {
    path: "/basket/success",
  },
  contracts: {
    path: "/contracts",
  },
  contractsAndRights: {
    path: "/contracts/contracts-and-rights",
  },
  // Download page
  download: {
    path: "/download",
  },
  //   // Registration
  //   register: {
  //     path: "/register",
  //   },
  //   registerProfileDetails: {
  //     path: "/register/profile",
  //   },
  //   registerProfileUser: {
  //     path: "/register/user",
  //   },
  // Login
  login: {
    path: "/login",
  },
  loginOkta: {
    path: "/login/okta",
  },
  loginNewPassword: {
    path: "/login/new-password",
  },
  loginForgotPasswordRequest: {
    path: "/login/password-recovery",
  },
  loginPasswordReset: {
    path: "/login/password-reset/:userId/:key",
  },
  loginExternalAccess: {
    path: "/login/external-access/:key",
  },
  newUser: {
    path: "/new-user",
  },
  lockedUser: {
    path: "/locked-user",
  },
  verifyEmail: {
    path: "/verify/:userId/:key",
  },
  // Share screening room links
  viewLink: {
    path: "/screeners",
  },
  viewLinkExpired: {
    path: "/screeners/expired",
  },
  viewLinkError: {
    path: "/screeners/error",
  },
  viewLinkProcessing: {
    path: "/screeners/processing",
  },
  // Dashboard
  dashboard: {
    path: "/dashboard",
  },
  dashboardConversations: {
    path: "/dashboard/conversations",
  },
  dashboardApprovals: {
    path: "/dashboard/approvals",
  },
  dashboardPurge: {
    path: "/dashboard/purge",
  },
  dashboardQC: {
    path: "/dashboard/workflow",
  },
  cockpit: {
    path: "/dashboard/cockpit",
  },
  kpiWorkflow: {
    path: "/dashboard/kpi-workflow",
  },
  activities: {
    path: "/dashboard/activities",
  },
  collections: {
    path: "/collections",
  },
  // Inventory and Search section
  inventory: {
    path: "/inventory",
  },
  inventoryAssets: {
    path: "/inventory/assets",
  },
  inventorySourceAdam: {
    path: "/inventory/sources",
  },
  inventoryCrossLevel: {
    path: "/inventory/cross-level",
  },
  inventoryAdvancedQueries: {
    path: "/inventory/advanced-queries",
  },
  inventoryKdm: {
    path: "/inventory/kdm",
  },
  inventoryCreateTitle: {
    path: "/inventory/manage-titles",
  },
  inventoryBundlesDashboard: {
    path: "/inventory/bundles",
  },
  // Shares
  shares: {
    path: "/shares",
  },
  // Title page
  titleHero: {
    path: "/titles/hero",
  },
  // Title page
  title: {
    path: "/titles",
  },
  titleAssets: {
    path: "assets",
  },
  titleDrive: {
    path: "drive",
  },
  titleMediaAndCollections: {
    path: "media-and-collections",
  },
  titleContracts: {
    path: "contracts",
  },
  titleOrders: {
    path: "orders",
  },
  titleShares: {
    path: "shares",
  },
  titleActivities: {
    path: "activities",
  },
  bundleMaker: {
    path: "/titles/:id/bundlemaker",
  },
  // Asset page
  asset: {
    path: "/assets",
  },
  assetMetadata: {
    path: "metadata",
  },
  assetPreview: {
    path: "preview",
  },
  assetHierarchy: {
    path: "hierarchy",
  },
  assetMediaFiles: {
    path: "files",
  },
  assetActions: {
    path: "actions",
  },
  assetShares: {
    path: "shares",
  },
  assetOrders: {
    path: "orders",
  },
  assetActivities: {
    path: "activities",
  },
  assetPermissions: {
    path: "permissions",
  },
  assetQuotas: {
    path: "quotas",
  },
  // Ingest section
  ingest: {
    path: "/ingest",
  },
  ingestAdamSources: {
    path: "/ingest/adam/sources",
  },
  ingestAdamTrailers: {
    path: "/ingest/adam/trailers",
  },
  ingestRequested: {
    path: "/ingest/requested",
  },
  ingestRejected: {
    path: "/ingest/rejected",
  },
  ingestApproved: {
    path: "/ingest/approved",
  },
  ingestPacks: {
    path: "/ingest/packs",
  },
  ingestPacksSingle: {
    path: "/ingest/packs",
  },
  ingestNewRequest: {
    path: "/ingest/new-request",
  },
  ingestMissingAssetRequest: {
    path: "/ingest/new-missing-asset-request",
  },
  ingestConfigurePlaceholder: {
    path: "/ingest/placeholders",
  },
  ingestConfigureColset: {
    path: "/ingest/column-set",
  },
  // Simplified page without tabs
  ordersOverview: {
    path: "/orders/overview",
  },
  // Detailled pages with tabs
  ordersBase: {
    path: "/orders",
  },
  ordersInternal: {
    path: "/orders/internal",
  },
  ordersItemDetails: {
    path: "/orders/items",
  },
  orderWatermarks: {
    path: "/orders/watermarks",
  },
  ordersItemQuoteDetails: {
    path: "/orders/quotes",
  },
  ordersItemSearch: {
    path: "/orders/search",
  },
  ordersInvoice: {
    path: "/orders/invoice",
  },
  // Customer section
  customers: {
    path: "/customers",
  },
  providers: {
    path: "/providers",
  },
  storefront: {
    path: "/storefront",
  },
  // Settings section

  // Group Broadcasters
  settingsGroupBroadcasters: {
    path: `/settings/${SettingsGroups.broadcasters}`,
  },

  settingsBroadcasters: {
    path: `/settings/${SettingsGroups.broadcasters}/broadcasters`,
  },
  settingsExportSessions: {
    path: `/settings/${SettingsGroups.broadcasters}/export-sessions`,
  },
  settingsExportSessionsLiquid: {
    path: `/settings/${SettingsGroups.broadcasters}/export-sessions/liquid`,
  },
  AdminSettingsYoutubeChannels: {
    path: `/settings/${SettingsGroups.broadcasters}/youtube-channels`,
  },

  // Group users
  settingsGroupUsers: {
    path: `/settings/${SettingsGroups.users}`,
  },

  settingsUsers: {
    path: `/settings/${SettingsGroups.users}/users`,
  },
  settingsRolesAndPermissions: {
    path: `/settings/${SettingsGroups.users}/roles-and-permissions`,
  },
  settingsPlanningResources: {
    path: `/settings/${SettingsGroups.users}/planning-resources`,
  },
  settingsMailingList: {
    path: `/settings/${SettingsGroups.users}/mailing-list`,
  },

  // Group orders
  settingsGroupOrders: {
    path: `/settings/${SettingsGroups.orders}`,
  },

  settingsOrders: {
    path: `/settings/${SettingsGroups.orders}/products`,
  },
  settingsPriceRulesManagement: {
    path: `/settings/${SettingsGroups.orders}/price-rules`,
  },
  settingsManualTasks: {
    path: `/settings/${SettingsGroups.orders}/manual-tasks`,
  },
  settingsManualTasksTemplateConfig: {
    path: `/settings/${SettingsGroups.orders}/manual-tasks/config`,
  },

  // Group inventory
  settingsGroupInventory: {
    path: `/settings/${SettingsGroups.inventory}`,
  },
  settingsInventory: {
    path: `/settings/${SettingsGroups.inventory}/metadatafields`,
  },
  settingsNamingRules: {
    path: `/settings/${SettingsGroups.inventory}/naming-rules`,
  },
  settingsLegacyImporter: {
    path: `/settings/${SettingsGroups.inventory}/legacy-importer`,
  },
  settingsFormats: {
    path: `/settings/${SettingsGroups.inventory}/formats`,
  },
  settingsMetadataViews: {
    path: `/settings/${SettingsGroups.inventory}/metadata-views`,
  },
  editMetadataViews: {
    path: `/settings/${SettingsGroups.inventory}/metadata-views/edit`,
  },
  createMetadataViews: {
    path: `/settings/${SettingsGroups.inventory}/metadata-views/create`,
  },
  settingsBulkMetaImporter: {
    path: `/settings/${SettingsGroups.inventory}/bulk-meta-importer`,
  },

  // Group Rules and automation
  settingsGroupRules: {
    path: `/settings/${SettingsGroups.system}`,
  },

  settingsSystem: {
    path: `/settings/${SettingsGroups.system}/jobs`,
  },
  settingsJobRules: {
    path: `/settings/${SettingsGroups.system}/job-rules`,
  },
  editJobRule: {
    path: `/settings/${SettingsGroups.system}/job-rules/edit`,
  },
  createJobRule: {
    path: `/settings/${SettingsGroups.system}/job-rules/create`,
  },
  settingsWorkflowModels: {
    path: `/settings/${SettingsGroups.system}/workflow-models`,
  },
  settingsWorkflowDesigner: {
    path: `/settings/${SettingsGroups.system}/workflow-designer`,
  },
  settingsPurgeRules: {
    path: `/settings/${SettingsGroups.system}/purge-rules`,
  },
  settingsStatusTransitions: {
    path: `/settings/${SettingsGroups.system}/status-transitions`,
  },
  // Group Platform
  settingsGroupPlatform: {
    path: `/settings/${SettingsGroups.platform}`,
  },
  settingsGlobal: {
    path: `/settings/${SettingsGroups.platform}/global`,
  },
  settingsSystemAlerts: {
    path: `/settings/${SettingsGroups.platform}/system-alerts`,
  },
  settingsSystemCultures: {
    path: `/settings/${SettingsGroups.platform}/cultures`,
  },
  settingsCopyPlatform: {
    path: `/settings/${SettingsGroups.platform}/copy-platform`,
  },
  settingsStorages: {
    path: `/settings/${SettingsGroups.platform}/storages`,
  },
  settingsAgentsAndLicenses: {
    path: `/settings/${SettingsGroups.platform}/agents-and-licences`,
  },

  // Reporting section
  reporting: {
    path: "/reporting",
  },
  reportingDataExporter: {
    path: "/reporting/data-exporter",
  },
  reportingCatalog: {
    path: "/reporting/catalog",
  },
  planning: {
    path: "/planning",
  },
  planningKanban: {
    path: "/planning/kanban",
  },
  followupOrder: {
    path: "/orders/followup",
  },
  // Support section
  support: {
    path: "/support",
  },
  supportDocuments: {
    path: "/support/documents",
  },
  supportBacklog: {
    path: "/support/backlog",
  },
  supportTickets: {
    path: "/support/tickets",
  },
  // Billing section
  billing: {
    path: "/billing",
  },
  billingDetails: {
    path: "/billing/details",
  },
  billingInvoices: {
    path: "/billing/invoices",
  },
  // Tools
  tools: {
    path: "/tools",
  },
  toolsQc: {
    path: "/tools/qc",
  },
  timetool: {
    path: "/timetool",
  },
  scribetool: {
    path: "/scribetool",
  },
};

const getRoutes = () => {
  const Routes: RouteObject[] = [
    {
      element: (
        <PageHeadRoute pageTitle={t("route:pageTitle.home")} navType={NavTypes.None} rootLink={routePaths.home.path}>
          <ProtectedRoute>
            <PlatformRoute Adam={<AdamIndex />} Browser={<CatalogIndex />} Distribution={<CatalogIndex />} />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.home.path,
    },

    /* --------- Dashboard --------- */
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.dashboard")}
          navType={NavTypes.LinkTabs}
          rootLink={routePaths.dashboard.path}
        >
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.dashboard.path}`,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("common:overview")}>
              <DashboardOverview />
            </LinkTabRoute>
          ),
          path: "",
          index: true,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.approvals")}>
              <DashboardApprovals />
            </LinkTabRoute>
          ),
          path: routePaths.dashboardApprovals.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.conversations")}>
              <DashboardConversations />
            </LinkTabRoute>
          ),
          path: routePaths.dashboardConversations.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.purges")}
              acls={[AclTypes.aclWorkflowPurgeView, AclTypes.aclSuperUser, AclTypes.aclAdmin]}
            >
              <DashboardPurge />
            </LinkTabRoute>
          ),
          path: routePaths.dashboardPurge.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.qualityCheckAndQualify")}
              acls={[
                AclTypes.aclWorkflowQualifyView,
                AclTypes.aclUserTaskView,
                AclTypes.aclSuperUser,
                AclTypes.aclAdmin,
              ]}
            >
              <DashboardQC />
            </LinkTabRoute>
          ),
          path: routePaths.dashboardQC.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.cockpit")} acls={[AclTypes.aclSuperUser]}>
              <Cockpit />
            </LinkTabRoute>
          ),
          path: routePaths.cockpit.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.kpiWorkflow")} acls={[AclTypes.aclSuperUser]}>
              <KpiWorkflow />
            </LinkTabRoute>
          ),
          path: routePaths.kpiWorkflow.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("common:activities")}
              acls={[AclTypes.aclSuperUser, AclTypes.aclBackofficeAuditLogsView]}
            >
              <DashboardActivities />
            </LinkTabRoute>
          ),
          path: routePaths.activities.path,
        },
      ],
    },

    /* --------- Drive --------- */
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.drive")}
          navType={NavTypes.LinkTabs}
          rootLink={routePaths.drive.path}
        >
          <ProtectedRoute>
            <Drive />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.drive.path,
      children: [
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.browser")}
              matchingPaths={[`${routePaths.drive.path}/:childId`, `${routePaths.drive.path}/:mode/:settings`]}
            >
              <DriveTreeview />
            </LinkTabRoute>
          ),
          path: "",
          index: true,
        },
        {
          element: <DriveTreeview />,
          path: `${routePaths.drive.path}/:childId`,
        },
        {
          element: <DriveTreeview />,
          path: `${routePaths.drive.path}/:mode/:settings`,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("common:trash")}
              acls={[AclTypes.aclObjectTrashView, AclTypes.aclObjectTrashDelete]}
              aclMatch={AclMatch.All}
            >
              <DriveTrash />
            </LinkTabRoute>
          ),

          path: `${routePaths.driveTrash.path}`,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.externalAccesses")} acls={[AclTypes.aclExternalAccessViewAll]}>
              <DriveExternalAccess />
            </LinkTabRoute>
          ),
          path: `${routePaths.driveExternalAccess.path}`,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:advancedQueries")} acls={[AclTypes.aclSuperUser]}>
              <AdminInventoryAdvancedQueries />
            </LinkTabRoute>
          ),
          path: `${routePaths.driveAdvancedQueries.path}`,
        },
      ],
    },

    /* --------- Catalog & Inventory --------- */
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.catalog")}
          navType={NavTypes.None}
          rootLink={routePaths.catalog.path}
        >
          <ProtectedRoute>
            <CatalogSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.catalog.path,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.catalog")}
          navType={NavTypes.None}
          rootLink={routePaths.catalog.path}
        >
          <ProtectedRoute>
            <CatalogSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.catalog.path}/:mode/:settings`,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.catalog")}
          navType={NavTypes.Breadcrumb}
          rootLink={routePaths.catalog.path}
        >
          <ProtectedRoute>
            <Title />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.titleHero.path}/:id`,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.inventory")}
          navType={NavTypes.LinkTabs}
          rootLink={routePaths.inventory.path}
        >
          <ProtectedRoute>
            <AdminInventory />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.inventory.path,
      children: [
        {
          element: (
            <PlatformRoute
              Distribution={
                <LinkTabRoute linkTitle={t("common:titles")}>
                  <AdminInventoryTitles />
                </LinkTabRoute>
              }
              Adam={routePaths.inventorySourceAdam.path}
              Browser={routePaths.drive.path}
            />
          ),
          path: "", // /inventory
          index: true,
        },
        {
          element: (
            <PlatformRoute
              Distribution={routePaths.inventory.path}
              Browser={routePaths.drive.path}
              Adam={
                <LinkTabRoute linkTitle={t("route:linkTitle.sources")}>
                  <AdamSources />
                </LinkTabRoute>
              }
            />
          ),
          path: routePaths.inventorySourceAdam.path,
        },
        {
          element: (
            <PlatformRoute
              Adam={
                <LinkTabRoute linkTitle={t("route:linkTitle.trailers")}>
                  <AdamTrailers />
                </LinkTabRoute>
              }
              Distribution={
                <LinkTabRoute linkTitle={t("common:assets")} accessLevel={AclAssetAccessLevel.Asset}>
                  <AdminInventoryAssets />
                </LinkTabRoute>
              }
              Browser={routePaths.drive.path}
            />
          ),
          path: routePaths.inventoryAssets.path,
        },
        {
          element: (
            <PlatformRoute
              Adam={routePaths.ingestAdamSources.path}
              Browser={routePaths.drive.path}
              Distribution={
                <LinkTabRoute linkTitle={t("route:linkTitle.crossSearch")} accessLevel={AclAssetAccessLevel.Asset}>
                  <AdminInventoryCrossLevel />
                </LinkTabRoute>
              }
            />
          ),
          path: routePaths.inventoryCrossLevel.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:advancedQueries")} acls={[AclTypes.aclSearchAdvancedEnable]}>
              <AdminInventoryAdvancedQueries />
            </LinkTabRoute>
          ),
          path: routePaths.inventoryAdvancedQueries.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.kdmRecipients")}
              acls={[AclTypes.aclKdmRecipientAdmin]}
              licence={Licences.DcpKDMFeature}
            >
              <InventoryKdm />
            </LinkTabRoute>
          ),
          path: routePaths.inventoryKdm.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle="Manage titles"
              acls={[AclTypes.aclTitleCreate]}
              licence={Licences.CatalogManagement}
            >
              <InventoryCreateTitle />
            </LinkTabRoute>
          ),
          path: routePaths.inventoryCreateTitle.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.bundlesDashboard")} acls={[AclTypes.aclBundleDashboardView]}>
              <InventoryBundlesDashboard />
            </LinkTabRoute>
          ),
          path: routePaths.inventoryBundlesDashboard.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.inventory")}
          rootLink={routePaths.inventory.path}
          navType={NavTypes.Breadcrumb}
        >
          <DriveRouteOverride>
            <ProtectedRoute>
              <AdminTitleSingle />
            </ProtectedRoute>
          </DriveRouteOverride>
        </PageHeadRoute>
      ),
      path: `${routePaths.title.path}/:id`,
      children: [
        {
          element: <AdminTitleSingleContentsAndMetadata />,
          path: "",
          index: true,
        },
        {
          element: <AdminTitleSingleAssets />,
          path: routePaths.titleAssets.path,
        },
        {
          element: <AdminTitleDrive />,
          path: `${routePaths.titleDrive.path}`,
        },
        {
          element: <AdminTitleDrive />,
          path: `${routePaths.titleDrive.path}/:childId`,
        },
        {
          element: <AdminTitleSingleMediaAndCollections />,
          path: routePaths.titleMediaAndCollections.path,
        },
        {
          element: <AdminTitleSingleContracts />,
          path: routePaths.titleContracts.path,
        },
        {
          element: <AdminTitleSingleOrders />,
          path: routePaths.titleOrders.path,
        },
        {
          element: <AdminTitleSingleShares />,
          path: routePaths.titleShares.path,
        },
        {
          element: <AdminTitleSingleActivities />,
          path: routePaths.titleActivities.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.inventory")}
          rootLink={routePaths.inventory.path}
          navType={NavTypes.Breadcrumb}
        >
          <ProtectedRoute>
            <InventoryAssetSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.asset.path}/:id`,
      children: [
        {
          element: <AssetSingleMetadata />,
          path: "",
          index: true,
        },
        {
          element: <AssetSinglePreview />,
          path: routePaths.assetPreview.path,
        },
        {
          element: <AssetSingleHierarchy />,
          path: routePaths.assetHierarchy.path,
        },
        {
          element: <AssetSingleMediaFiles />,
          path: routePaths.assetMediaFiles.path,
        },
        {
          element: <AssetSingleActions />,
          path: routePaths.assetActions.path,
        },
        {
          element: <AssetSingleShares />,
          path: routePaths.assetShares.path,
        },
        {
          element: <AssetSingleOrders />,
          path: routePaths.assetOrders.path,
        },
        {
          element: <AssetSingleActivities />,
          path: routePaths.assetActivities.path,
        },
        {
          element: <AssetSingleQuotas />,
          path: routePaths.assetQuotas.path,
        },
      ],
    },

    /*{
        Remove /collections => not used
        element: (
        <ProtectedRoute>
            <CatalogCollections />
        </ProtectedRoute>
        ),
        path: routePaths.collections.path,
    },*/

    /* --------- Ingests & Requests --------- */
    {
      element: (
        <ProtectedRoute>
          <AdminIngestNewRequest />
        </ProtectedRoute>
      ),
      path: `${routePaths.ingestNewRequest.path}/:id`,
    },
    {
      element: (
        <ProtectedRoute>
          <AdminIngestMissingAssetRequest />
        </ProtectedRoute>
      ),
      path: routePaths.ingestMissingAssetRequest.path,
    },
    {
      element: (
        <PageHeadRoute navType={NavTypes.LinkTabs} pageTitle={t("common:ingests")} rootLink={routePaths.ingest.path}>
          <ProtectedRoute>
            <AdminIngest />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.ingest.path,
      children: [
        {
          element: (
            <PlatformRoute
              Distribution={
                <LinkTabRoute linkTitle={t("common:processing")}>
                  <AdminIngestProcessing />
                </LinkTabRoute>
              }
              Browser={
                <LinkTabRoute linkTitle={t("common:processing")}>
                  <AdminIngestProcessing />
                </LinkTabRoute>
              }
              Adam={routePaths.ingestAdamSources.path}
            />
          ),
          path: "",
          index: true,
        },
        {
          element: (
            <PlatformRoute
              Distribution={routePaths.ingest.path}
              Browser={routePaths.ingest.path}
              Adam={
                <LinkTabRoute linkTitle={t("route:linkTitle.sources")}>
                  <AdminIngestProcessing />
                </LinkTabRoute>
              }
            />
          ),
          index: true,
          path: routePaths.ingestAdamSources.path,
        },
        {
          element: (
            <PlatformRoute
              Distribution={routePaths.ingest.path}
              Browser={routePaths.ingest.path}
              Adam={
                <LinkTabRoute linkTitle={t("route:linkTitle.trailers")} acls={[AclTypes.aclSuperUser]}>
                  <AdminIngestProcessing />
                </LinkTabRoute>
              }
            />
          ),
          path: routePaths.ingestAdamTrailers.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.requested")}
              acls={[AclTypes.aclIngestUpload]}
              platformModes={[PlatformMode.Distribution]}
            >
              <AdminIngestRequested />
            </LinkTabRoute>
          ),
          path: routePaths.ingestRequested.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:rejected")} acls={[AclTypes.aclIngestRejectionsView]}>
              <AdminIngestRejected />
            </LinkTabRoute>
          ),
          path: routePaths.ingestRejected.path,
        },
        {
          element: <AdminIngestApproved />,
          path: routePaths.ingestApproved.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.packs")}
              acls={[AclTypes.aclIngestConfigCreation]}
              platformModes={[PlatformMode.Distribution]}
              matchingPaths={[`${routePaths.ingestPacksSingle.path}/:id`]}
            >
              <AdminIngestPacksIndex />
            </LinkTabRoute>
          ),
          path: routePaths.ingestPacks.path,
        },
        {
          element: <AdminIngestPacksSingle />,
          path: `${routePaths.ingestPacksSingle.path}/:id`,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.columnSet")}
              acls={[AclTypes.aclIngestConfigColumnSetCreate, AclTypes.aclIngestConfigColumnSetUpdate]}
              platformModes={[PlatformMode.Distribution]}
            >
              <IngestConfigColset />
            </LinkTabRoute>
          ),
          path: routePaths.ingestConfigureColset.path,
        },
      ],
    },
    {
      element: (
        <ProtectedRoute>
          <AdminIngestNewRequest />
        </ProtectedRoute>
      ),
      path: routePaths.ingestNewRequest.path,
    },
    {
      element: (
        <ProtectedRoute>
          <AdminIngestMissingAssetRequest />
        </ProtectedRoute>
      ),
      path: routePaths.ingestMissingAssetRequest.path,
    },
    {
      element: (
        <ProtectedRoute>
          <AdminIngestConfigurePlaceholder context={IngestConfigurePlaceholderContext.Update} />
        </ProtectedRoute>
      ),
      path: `${routePaths.ingestConfigurePlaceholder.path}/update/:id`,
    },
    {
      element: (
        <ProtectedRoute>
          <AdminIngestConfigurePlaceholder context={IngestConfigurePlaceholderContext.Duplicate} />
        </ProtectedRoute>
      ),
      path: `${routePaths.ingestConfigurePlaceholder.path}/duplicate/:id`,
    },
    {
      element: (
        <ProtectedRoute>
          <AdminIngestConfigurePlaceholder context={IngestConfigurePlaceholderContext.Create} />
        </ProtectedRoute>
      ),
      path: `${routePaths.ingestConfigurePlaceholder.path}/new`,
    },

    /* --------- Orders --------- */
    {
      element: (
        <PageHeadRoute pageTitle={t("common:orders")} navType={NavTypes.None} rootLink={routePaths.ordersOverview.path}>
          <ProtectedRoute>
            <OrderListBasic />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.ordersOverview.path,
    },
    {
      element: (
        <PageHeadRoute pageTitle={t("common:orders")} navType={NavTypes.LinkTabs} rootLink={routePaths.ingest.path}>
          <ProtectedRoute>
            {/* Use no max width for order items due to large data amount */}
            <AdminOrder />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.ordersBase.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.customerOrders")}>
              <AdminOrderCustomerOrders />
            </LinkTabRoute>
          ),
          path: "",
          index: true,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.internalOrders")}>
              <OrderInternal />
            </LinkTabRoute>
          ),
          path: routePaths.ordersInternal.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.itemDetails")}>
              <OrderItemDetails />
            </LinkTabRoute>
          ),
          path: routePaths.ordersItemDetails.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.orderQuotes")}
              acls={[AclTypes.aclOrderQuoteView]}
              licence={Licences.QuoteManagement}
            >
              <OrderItemQuoteDetails />
            </LinkTabRoute>
          ),
          path: routePaths.ordersItemQuoteDetails.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:search")}>
              <OrderItemSearch />
            </LinkTabRoute>
          ),
          path: routePaths.ordersItemSearch.path,
        },
        {
          element: (
            <LinkTabRoute
              acls={[AclTypes.aclSuperUser, AclTypes.aclAdmin]}
              licence={Licences.WatermarkNexguardCivolution}
              linkTitle="Watermarks"
            >
              <OrderWatermarks />
            </LinkTabRoute>
          ),
          path: routePaths.orderWatermarks.path,
        },
      ],
    },
    {
      element: <OrderFollowup />,
      path: `${routePaths.followupOrder.path}/:orderId/:key`,
    },
    /* Unused as of today
    {
      element: (
        <PageHeadRoute pageTitle="Orders" navType={NavTypes.Breadcrumb} rootLink={routePaths.ordersBase.path}>
          <ProtectedRoute>
            <AdminOrderSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.ordersBase.path}/:id`,
    },
    */
    // There is OrderSingle (pretty basic) and OrderSingleBasic (much complete)
    {
      element: (
        <PageHeadRoute
          pageTitle={t("common:orders")}
          navType={NavTypes.Breadcrumb}
          rootLink={routePaths.ordersOverview.path}
        >
          <ProtectedRoute>
            <OrderSingleAdvanced />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.ordersOverview.path}/:orderId`,
    },

    /* --------- Customers, Providers & Contracts --------- */
    {
      element: (
        <PageHeadRoute pageTitle={t("common:customers")} navType={NavTypes.None} rootLink={routePaths.customers.path}>
          <ProtectedRoute>
            <AdminCustomersCustomers />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.customers.path,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("common:customers")}
          navType={NavTypes.Breadcrumb}
          rootLink={routePaths.customers.path}
        >
          <ProtectedRoute>
            <AdminCustomersSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.customers.path}/:id`,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.contracts")}
          navType={NavTypes.LinkTabs}
          rootLink={routePaths.contracts.path}
        >
          <ProtectedRoute>
            <Contracts />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.contracts.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.recentTitles")}>
              <ContractTitles />
            </LinkTabRoute>
          ),
          path: "",
          index: true,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.contractsAndRights")}>
              <ContractsAndRights />
            </LinkTabRoute>
          ),
          path: routePaths.contractsAndRights.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.contracts")}
          navType={NavTypes.Breadcrumb}
          rootLink={routePaths.contractsAndRights.path}
        >
          <ProtectedRoute>
            <AdminCustomerContractSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.contractsAndRights.path}/:id`,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.providers")}
          navType={NavTypes.None}
          rootLink={routePaths.providers.path}
        >
          <ProtectedRoute>
            <AdminProviders />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.providers.path,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.providers")}
          navType={NavTypes.Breadcrumb}
          rootLink={routePaths.providers.path}
        >
          <ProtectedRoute>
            <AdminProvidersSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.providers.path}/:id`,
    },
    {
      element: (
        <ProtectedRoute>
          <AdminCustomersSingle />
        </ProtectedRoute>
      ),
      path: `${routePaths.customers.path}/:id`,
    },

    /* --------- Basket --------- */
    {
      element: (
        <ProtectedRoute>
          <BasketMainFrame />
        </ProtectedRoute>
      ),
      path: routePaths.basket.path,
    },
    {
      element: (
        <ProtectedRoute>
          <BasketCheckout />
        </ProtectedRoute>
      ),
      path: routePaths.basketCheckout.path,
    },
    {
      element: (
        <ProtectedRoute>
          <BasketSuccess context={InvoiceContext.Basket} />
        </ProtectedRoute>
      ),
      path: `${routePaths.basketSuccess.path}/:orderId`,
    },
    {
      element: (
        <ProtectedRoute>
          <BasketSuccess context={InvoiceContext.Order} />
        </ProtectedRoute>
      ),
      path: `${routePaths.ordersInvoice.path}/:orderId`,
    },

    /* --------- Login & Register --------- */
    // {
    //   element: (
    //     <ProtectedRoute>
    //       <Register />
    //     </ProtectedRoute>
    //   ),
    //   path: routePaths.register.path,
    // },
    // {
    //   element: (
    //     <ProtectedRoute>
    //       <Register />
    //     </ProtectedRoute>
    //   ),
    //   path: `${routePaths.register.path}/:brand`,
    // },
    // {
    //   element: (
    //     <ProtectedRoute>
    //       <RegisterProfileDetails />
    //     </ProtectedRoute>
    //   ),
    //   path: `${routePaths.registerProfileDetails.path}`,
    // },
    // {
    //   element: (
    //     <ProtectedRoute>
    //       <RegisterProfileUser />
    //     </ProtectedRoute>
    //   ),
    //   path: `${routePaths.registerProfileUser.path}`,
    // },
    {
      element: <Login />,
      path: `${routePaths.login.path}`,
    },
    {
      element: <LoginOkta />,
      path: `${routePaths.loginOkta.path}`,
    },
    {
      element: <LoginByKey />,
      path: `${routePaths.login.path}/:key`,
    },
    {
      element: <LoginNewPassword />,
      path: `${routePaths.loginNewPassword.path}`,
    },
    {
      element: <LoginExternalAccess />,
      path: `${routePaths.loginExternalAccess.path}`,
    },
    {
      element: <NewUserWaiting />,
      path: `${routePaths.newUser.path}`,
    },
    {
      element: <LockedUser />,
      path: `${routePaths.lockedUser.path}`,
    },
    {
      element: <LoginVerify />,
      path: `${routePaths.verifyEmail.path}`,
    },
    {
      element: <LoginForgotPasswordRequest />,
      path: `${routePaths.loginForgotPasswordRequest.path}`,
    },
    {
      element: <LoginForgotPasswordReset />,
      path: `${routePaths.loginPasswordReset.path}`,
    },

    /* --------- Demo --------- */
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.demo")}
          navType={NavTypes.LinkTabs}
          rootLink={routePaths.demo.path}
        >
          <ProtectedRoute>
            <BasketMainFrame />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.basket.path,
    },
    {
      element: (
        <ProtectedRoute>
          <BasketCheckout />
        </ProtectedRoute>
      ),
      path: routePaths.basketCheckout.path,
    },
    {
      element: (
        <ProtectedRoute>
          <BasketSuccess context={InvoiceContext.Basket} />
        </ProtectedRoute>
      ),
      path: `${routePaths.basketSuccess.path}/:orderId`,
    },
    {
      element: (
        <ProtectedRoute>
          <BasketSuccess context={InvoiceContext.Order} />
        </ProtectedRoute>
      ),
      path: `${routePaths.ordersInvoice.path}/:orderId`,
    },
    /* --------- Demo --------- */
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.demo")}
          navType={NavTypes.LinkTabs}
          rootLink={routePaths.demo.path}
        >
          <ProtectedRoute>
            <Demo />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.demo.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("common:core")}>
              <DemoCore />
            </LinkTabRoute>
          ),
          path: "",
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.samples")}>
              <DemoSamples />
            </LinkTabRoute>
          ),
          path: routePaths.demoSamples.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.tables")}>
              <DemoTables />
            </LinkTabRoute>
          ),
          path: routePaths.demoTables.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:cards")}>
              <DemoCards />
            </LinkTabRoute>
          ),
          path: routePaths.demoCards.path,
        },
      ],
    },

    /* --------- Share & Download --------- */
    { element: <DownloadLink />, path: `${routePaths.download.path}/:key` },
    {
      element: <ViewLink />,
      path: `${routePaths.viewLink.path}/:key`,
    },
    {
      element: <ViewLinkExpired />,
      path: `${routePaths.viewLinkExpired.path}/:key`,
    },
    {
      element: <ViewLinkError />,
      path: `${routePaths.viewLinkError.path}/:key`,
    },
    {
      element: <ViewLinkProcessing />,
      path: `${routePaths.viewLinkProcessing.path}/:key`,
    },
    {
      element: (
        <PageHeadRoute pageTitle={t("common:shares")} navType={NavTypes.LinkTabs} rootLink={routePaths.shares.path}>
          <ProtectedRoute>
            <Shares />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.shares.path,
      children: [
        {
          element: <SharesList />,
          path: "",
          index: true,
        },
      ],
    },

    /* --------- Collections & Storefront --------- */
    {
      element: (
        <PageHeadRoute
          pageTitle={t("common:collections")}
          navType={NavTypes.None}
          rootLink={routePaths.collections.path}
        >
          <ProtectedRoute>
            <AdminCollection />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.collections.path,
    },
    {
      element: (
        <ProtectedRoute>
          <AdminCollection />
        </ProtectedRoute>
      ),
      path: `${routePaths.collections.path}/empty`,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("common:collections")}
          navType={NavTypes.Breadcrumb}
          rootLink={routePaths.collections.path}
        >
          <ProtectedRoute>
            <AdminCollectionSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.collections.path}/:id`,
    },
    {
      element: (
        <ProtectedRoute>
          <AdminCollectionSingle />
        </ProtectedRoute>
      ),
      path: `${routePaths.collections.path}/:id/:empty`,
    },
    {
      element: (
        <PageHeadRoute
          pageTitle={t("route:pageTitle.storefronts")}
          navType={NavTypes.None}
          rootLink={routePaths.storefront.path}
        >
          <ProtectedRoute>
            <AdminStorefront />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.storefront.path,
    },
    {
      element: (
        <PageHeadRoute
          navType={NavTypes.Breadcrumb}
          pageTitle={t("route:pageTitle.storefronts")}
          rootLink={routePaths.storefront.path}
        >
          <ProtectedRoute>
            <AdminCollectionSingle />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: `${routePaths.storefront.path}/:id`,
    },

    /* --------- Settings --------- */
    {
      element: (
        <PageHeadRoute pageTitle={t("route:pageTitle.settingsBroadcasters")} navType={NavTypes.LinkTabs} rootLink="#">
          <ProtectedRoute>
            <AdminSettings />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.settingsGroupBroadcasters.path,
      children: [
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.list")}
              acls={[AclTypes.aclSuperUser, AclTypes.aclSectionBackofficeAccess]}
            >
              <AdminSettingsBroadcasters />
            </LinkTabRoute>
          ),
          path: routePaths.settingsBroadcasters.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("common:exportSessions")}
              acls={[AclTypes.aclSuperUser, AclTypes.aclMetadataExport]}
            >
              <AdminSettingsExportSessions />
            </LinkTabRoute>
          ),
          path: routePaths.settingsExportSessions.path,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("common:youtubeChannels")}
              acls={[AclTypes.aclBackofficeYoutubeChannel, AclTypes.aclSuperUser]}
            >
              <AdminSettingsYoutubeChannels />
            </LinkTabRoute>
          ),
          path: routePaths.AdminSettingsYoutubeChannels.path,
        },
        {
          element: <AdminSettingsLiquidExportEdit />,
          path: `${routePaths.settingsExportSessionsLiquid.path}/:id`,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute pageTitle={t("route:pageTitle.settingsUsers")} navType={NavTypes.LinkTabs} rootLink="#">
          <ProtectedRoute>
            <AdminSettings />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.settingsGroupUsers.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.list")}>
              <AdminSettingsUsers />
            </LinkTabRoute>
          ),
          path: routePaths.settingsUsers.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.rolesAndPermissions")}>
              <AdminSettingsRolesAndPermissions />
            </LinkTabRoute>
          ),
          path: routePaths.settingsRolesAndPermissions.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.mailingLists")}>
              <AdminSettingsMailingListManagement />
            </LinkTabRoute>
          ),
          path: routePaths.settingsMailingList.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:planningResources")}>
              <AdminSettingsPlanningResources />
            </LinkTabRoute>
          ),
          path: routePaths.settingsPlanningResources.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute pageTitle={t("route:pageTitle.settingsOrders")} navType={NavTypes.LinkTabs} rootLink="#">
          <ProtectedRoute>
            <AdminSettings />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.settingsGroupOrders.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.products")}>
              <AdminSettingsProductsManagement />
            </LinkTabRoute>
          ),
          path: routePaths.settingsOrders.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:manualTasks")}>
              <AdminSettingsManualTasks />
            </LinkTabRoute>
          ),
          path: routePaths.settingsManualTasks.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:priceRules")}>
              <AdminSettingsPriceRulesManagement />
            </LinkTabRoute>
          ),
          path: routePaths.settingsPriceRulesManagement.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute pageTitle={t("route:pageTitle.settingsInventory")} navType={NavTypes.LinkTabs} rootLink="#">
          <ProtectedRoute>
            <AdminSettings />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.settingsGroupInventory.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("common:metadataFields")}>
              <AdminSettingsMetadataFields />
            </LinkTabRoute>
          ),
          path: routePaths.settingsInventory.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:namingRules")}>
              <AdminSettingsNamingRules />
            </LinkTabRoute>
          ),
          path: routePaths.settingsNamingRules.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:metadataViews")}>
              <AdminSettingsMetadataViewsManagement />
            </LinkTabRoute>
          ),
          path: routePaths.settingsMetadataViews.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:formats")}>
              <AdminSettingsFormats />
            </LinkTabRoute>
          ),
          path: routePaths.settingsFormats.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:legacyImporter")}>
              <AdminSettingsLegacyImporter />
            </LinkTabRoute>
          ),
          path: routePaths.settingsLegacyImporter.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.bulkMetadataImporter")}>
              <InventoryBulkMetaImporter />
            </LinkTabRoute>
          ),
          path: routePaths.settingsBulkMetaImporter.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute pageTitle={t("route:pageTitle.settingsRules")} navType={NavTypes.LinkTabs} rootLink="#">
          <ProtectedRoute>
            <AdminSettings />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.settingsGroupRules.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("common:jobs")}>
              <AdminSettingsJobs />
            </LinkTabRoute>
          ),
          path: routePaths.settingsSystem.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:jobRules")}>
              <AdminSettingsJobRulesManagement />
            </LinkTabRoute>
          ),
          path: routePaths.settingsJobRules.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:purgeRules")}>
              <AdminSettingsPurgeRules />
            </LinkTabRoute>
          ),
          path: routePaths.settingsPurgeRules.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:workflowsModels")}>
              <AdminSettingsWorkflows />
            </LinkTabRoute>
          ),
          path: routePaths.settingsWorkflowModels.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:workflowsDesigner")}>
              <SettingsDiagramDesigner />
            </LinkTabRoute>
          ),
          path: routePaths.settingsWorkflowDesigner.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.statusTransitions")}>
              <AdminSettingsStatusTransitions />
            </LinkTabRoute>
          ),
          path: routePaths.settingsStatusTransitions.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute pageTitle={t("route:pageTitle.settingsPlatform")} navType={NavTypes.LinkTabs} rootLink="#">
          <ProtectedRoute>
            <AdminSettings />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.settingsGroupPlatform.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("common:global")}>
              <AdminSettingsGlobal />
            </LinkTabRoute>
          ),
          path: routePaths.settingsGlobal.path,
          index: true,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.copyPlatform")}>
              <AdminSettingsCopyPlatform />
            </LinkTabRoute>
          ),
          path: routePaths.settingsCopyPlatform.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("common:storages")}>
              <AdminSettingsStorages />
            </LinkTabRoute>
          ),
          path: routePaths.settingsStorages.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.agentsAndLicenses")}>
              <AdminSettingsAgentsAndLicenses />
            </LinkTabRoute>
          ),
          path: routePaths.settingsAgentsAndLicenses.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.systemAlerts")}>
              <AdminSettingsSystemAlerts />
            </LinkTabRoute>
          ),
          path: routePaths.settingsSystemAlerts.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle="Cultures">
              <AdminSettingsSystemCultures />
            </LinkTabRoute>
          ),
          path: routePaths.settingsSystemCultures.path,
        },
      ],
    },

    /* --------- CRUDs --------- */
    {
      element: <EditOrCreateJobRule />,
      path: routePaths.editJobRule.path,
    },
    {
      element: <EditOrCreateJobRule />,
      path: routePaths.createJobRule.path,
    },
    {
      element: <EditOrCreateMetadataViews />,
      path: routePaths.editMetadataViews.path,
    },
    {
      element: <EditOrCreateMetadataViews />,
      path: routePaths.createMetadataViews.path,
    },

    /* --------- Reporting, Planning, Support & Billing --------- */
    {
      element: (
        <PageHeadRoute
          navType={NavTypes.LinkTabs}
          pageTitle={t("common:reporting")}
          rootLink={routePaths.reporting.path}
        >
          <ProtectedRoute>
            <Reporting />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.reporting.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("common:metricsUpperCase")}>
              <ReportingMetrics />
            </LinkTabRoute>
          ),
          path: "",
          index: true,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.dataExporter")}>
              <ReportingDataExporter />
            </LinkTabRoute>
          ),
          path: routePaths.reportingDataExporter.path,
        },
        {
          element: (
            <LinkTabRoute
              platformModes={[PlatformMode.Distribution]}
              acls={[AclTypes.aclMetricView, AclTypes.aclSuperUser]}
              linkTitle={t("route:pageTitle.catalog")}
            >
              <ReportingCatalog />
            </LinkTabRoute>
          ),
          path: routePaths.reportingCatalog.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute navType={NavTypes.LinkTabs} pageTitle={t("common:planning")} rootLink={routePaths.planning.path}>
          <ProtectedRoute>
            <Planning />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.planning.path,
      children: [
        {
          element: (
            <LinkTabRoute
              linkTitle={t("common:calendar")}
              acls={[AclTypes.aclPlanningUserTaskView]}
              licence={Licences.PlanningUserTaskCalendar}
            >
              <PlanningCalendar />
            </LinkTabRoute>
          ),
          path: "",
          index: true,
        },
        {
          element: (
            <LinkTabRoute
              linkTitle={t("route:linkTitle.kanban")}
              acls={[AclTypes.aclPlanningUserTaskView]}
              licence={Licences.PlanningUserTaskKanban}
            >
              <PlanningKanban />
            </LinkTabRoute>
          ),
          path: routePaths.planningKanban.path,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute navType={NavTypes.LinkTabs} pageTitle={t("common:support")} rootLink={routePaths.support.path}>
          <ProtectedRoute>
            <Support />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.support.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("common:documents")} acls={[AclTypes.aclDocumentsAccess]}>
              <SupportDocuments />
            </LinkTabRoute>
          ),
          path: routePaths.supportDocuments.path,
          index: true,
        },
      ],
    },
    {
      element: (
        <PageHeadRoute navType={NavTypes.LinkTabs} pageTitle={t("common:billing")} rootLink={routePaths.billing.path}>
          <ProtectedRoute>
            <Billing />
          </ProtectedRoute>
        </PageHeadRoute>
      ),
      path: routePaths.billing.path,
      children: [
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.offer")}>
              <BillingOffer />
            </LinkTabRoute>
          ),
          path: routePaths.billing.path,
          index: true,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.currentMonth")}>
              <BillingCurrentMonth />
            </LinkTabRoute>
          ),
          path: routePaths.billingDetails.path,
        },
        {
          element: (
            <LinkTabRoute linkTitle={t("route:linkTitle.invoices")}>
              <BillingInvoices />
            </LinkTabRoute>
          ),
          path: routePaths.billingInvoices.path,
        },
        {
          element: <BillingInvoiceDetails />,
          path: `${routePaths.billingInvoices.path}/:invoiceId`,
        },
      ],
    },

    /* --------- Tools --------- */
    {
      element: (
        <ProtectedRoute>
          <QcTool />
        </ProtectedRoute>
      ),
      path: `${routePaths.toolsQc.path}/:id`,
    },
    {
      element: (
        <ProtectedRoute>
          <BundleMaker />
        </ProtectedRoute>
      ),
      path: routePaths.bundleMaker.path,
    },
    {
      element: <AdminSettingsManualTasksTemplateConfig />,
      path: `${routePaths.settingsManualTasksTemplateConfig.path}/:id`,
    },
    {
      element: (
        <ProtectedRoute>
          <Timetool />
        </ProtectedRoute>
      ),
      path: routePaths.timetool.path,
    },
    {
      element: (
        <ProtectedRoute>
          <Timetool />
        </ProtectedRoute>
      ),
      path: `${routePaths.timetool.path}/:id`,
    },
    {
      element: (
        <ProtectedRoute>
          <Scribetool />
        </ProtectedRoute>
      ),
      path: `${routePaths.scribetool.path}/:assetId`,
    },
  ];

  // Do in last setp
  Routes.push({
    element: <Navigate to="/" />,
    path: `*`,
  });

  return Routes;
};

export { routePaths, getRoutes };
